import {PREMIUM} from "../constants/premium";
import {PRIMARY_COLOR} from "../styles/constants";

/**
 * Предложения премиума в магазине. priceRub — цена в рублях: она же
 * показывается на плашке товара и в модалке (см. ShopPremiumItem,
 * PremiumInfoModal). Покупка пока не подключена — попытка купить открывает
 * модалку раннего доступа с разовой наградой
 * (см. configs/purchaseInterestRewards.js)
 */

// Базовая цена месяца премиума: от нее считается выгода длинных предложений
export const PREMIUM_MONTH_PRICE_RUB = 190;

export const PREMIUM_CONFIGS = [{
  id: PREMIUM.MONTH_1,
  name: 'Премиум на 1 месяц',
  priceRub: PREMIUM_MONTH_PRICE_RUB,
}, {
  id: PREMIUM.MONTH_3,
  name: 'Премиум на 3 месяца',
  priceRub: 490,
  // 570 ₽ по месячной цене
  discountPercents: 14,
}, {
  id: PREMIUM.MONTH_12,
  name: 'Премиум на 12 месяцев',
  priceRub: 1490,
  // 2280 ₽ по месячной цене
  discountPercents: 34,
}, {
  id: PREMIUM.MONTH_12_AND_CRYSTALS_10000,
  name: 'Премиум на 12 месяцев',
  bonusCrystals: 10000,
  priceRub: 2990,
  // 2280 ₽ за год плюс 1900 ₽ за 10000 кристаллов по базовой цене
  discountPercents: 28,
  backgroundColor: PRIMARY_COLOR,
}]